import React from 'react';
import ResourceConsultation from './ResourceConsultation';

const headings = Object.freeze({ immediate_safety: 'Immediate protection and escalation',
  clarification: 'Questions that change the next decision', diagnostic: 'Recommended evaluation',
  supportive_care: 'Supportive comfort care',
  treatment: 'Proposed treatment', follow_up: 'Reassessment and follow-up',
  referral: 'Specialist referral — proposed, not placed' });

export default function ReviewedConsultation({ value, diagnosis, interaction, rationale }) {
  return <div className="response" aria-live="polite">
    <p role="note"><strong>Evaluation output — not authorized for clinical use.</strong></p>
    <p>This is a separately model-reviewed draft, not independent specialist approval or a signed order.</p>
    <section className="resp-section">
      <h4>Clinical assessment</h4>
      <p>{diagnosis || interaction.working_impression}</p>
      <p>{interaction.state.replaceAll('_', ' ')} · {interaction.urgency.replaceAll('_', ' ')}</p>
    </section>
    {value.differential.length > 0 && <section className="resp-section">
      <h4>Alternative diagnoses</h4>
      <ul>{value.differential.map((v) => <li key={v.id}>{v.text}</li>)}</ul>
    </section>}
    {value.actions.length > 0 && <section className="resp-section">
      <h4>Reviewed actions — proposed, not performed</h4>
      <ol>{value.actions.map((action) => <li key={action.id}>
        <strong>{action.kind === 'clarification' && interaction.state === 'URGENT_ESCALATION'
          ? 'Handoff information for the receiving team' : headings[action.kind]}</strong>
        <p style={{ whiteSpace: 'pre-wrap' }}>{action.text}</p>
        <p>{action.rationale}</p>
        {action.evidence_ids.length > 0 && <p>Supporting references: {action.evidence_ids.join(', ')}</p>}
        {action.uncertainty_ids.length > 0 && <p>Related open decisions: {action.uncertainty_ids.join(', ')}</p>}
      </li>)}</ol>
    </section>}
    {value.decisions.length > 0 && <section className="resp-section">
      <h4>Unresolved decisions</h4>
      <ul>{value.decisions.map((v) => <li key={v.id}>
        <strong>{v.id}</strong><p>{v.text}</p><p>{v.consequence}</p>
        {v.blocks_treatment && <p>Treatment prerequisite remains unresolved.</p>}
      </li>)}</ul>
    </section>}
    {value.sources.length > 0 && <section className="resp-section">
      <h4>Evidence supporting these actions</h4>
      <ul>{value.sources.map((v) => <li key={v.id}>
        <strong>{v.id}: </strong>
        {v.url ? <a href={v.url} target="_blank" rel="noopener noreferrer">{v.title}</a> : <span>{v.title}</span>}
        <p>{v.source} · {v.role.replaceAll('_', ' ')}</p>
        {v.qualification_scope && <><p>{v.publisher} · {v.edition} · {v.locator}</p>
          <p>Identity and exact excerpt only — not clinical approval.</p></>}
      </li>)}</ul>
    </section>}
    <ResourceConsultation value={value.resources} />
    {rationale && <section className="resp-section"><details open>
      <summary>Complete reviewed explanation</summary>
      <p style={{ whiteSpace: 'pre-wrap' }}>{rationale}</p>
    </details></section>}
  </div>;
}
